module.exports = __webpack_public_path__ + "img/20.55aef733.webp";